import _ from 'underscore';
import { stringifySync } from '@bingads-webui/safe-json';

export const getVideoODataService = ({
  odata, oDataConfig, aid, cid,
}) => {
  const addVideoCreative = ({ videoCreative, sourceType }) => {
    const url = `${oDataConfig.oDataPath}/Customers(${cid})/Accounts(${aid})/Videos/Default.CreateVideo`;

    const requestBody = {
      videoUrl: videoCreative.url,
      description: '',
      metadata: stringifySync(videoCreative),
      ...(sourceType && { sourceType }),
    };

    return odata.post(url, _.extend({ data: requestBody }, oDataConfig));
  };

  const getVideo = ({ id, fetchMetadata }) => {
    let url = `${oDataConfig.oDataPath}/Customers(${cid})/Accounts(${aid})/Videos(${id})`;

    if (fetchMetadata) {
      url = `${url}?fetchMetadata=true`;
    }
    return odata.get(url, oDataConfig);
  };

  return {
    addVideoCreative,
    getVideo,
  };
};
